/*///////////////////////////////////////////////////////////////
// lrcsarousel
// v1.0.0
///////////////////////////////////////////////////////////////*/

var angular = require('angular');
var _module = angular.module('benoit');
var $ = require('jquery');

require('./_styles.scss');
require('../third-party/jquery-transform/jquery.transform2d');
require('../../services/lr-touch');

_module.controller('LRCarouselCtrl', [
    '$log',
    '$scope',
    '$timeout',
    '$element',
    '$lrTouchStart',
    '$lrTouchMove',
    '$lrTouchEnd',

    function LRCarouselCtrl($log, $scope, $timeout, $element, $lrTouchStart, $lrTouchMove, $lrTouchEnd) {
        $log.debug('LRCarouselCtrl', this);

        $element = $($element);
        // Hide our main element by default
        $element.css('display', 'none');

        var $window = $(window);
        var $wrap = $($element.find('.lrcarousel-wrap'));
        var speed = 500;
        var vm = this;
        vm.model = {
            currentSlide: 0,
            hideArrows: true,
            animating: false,
            dragging: false
        };
        vm.events = {
            onArrowClick: onArrowClick
        };


        ///////////////////////////////////////////////////
        // $watch Functions
        ///////////////////////////////////////////////////
        $scope.$watch(function () { return vm.numAcross; }, function (newVal, oldVal) {
            // When the numAcross changes and we have children
            // fire the reorderChildren function.
            if(newVal && $wrap.children().length) {
                reorderChildren();
            }
        });


        ///////////////////////////////////////////////////
        // Functions
        ///////////////////////////////////////////////////
        function getNumAcross() {
            var children = $element.find('.lrcarousel-wrap').children();
            return Math.min(children.length, parseInt(vm.numAcross)) || 1;
        }

        // Removes Clones and replaces them
        // with the real elements.
        function reorderChildren(direction) {
            // Remove our clones
            $element.find('.slide-clone').remove();

            var movableChildren;
            // Get all the slides
            var children = $wrap.children();
            // Get the number across we are currently showing
            var numAcross = getNumAcross();

            // Hide arrows if we shouldn't scroll
            vm.model.hideArrows = !!(children.length <= numAcross);

            // Move the real elements where the clones were
            if(direction === 'next') {
                movableChildren = $(children.slice(0, numAcross));
                $wrap.append(movableChildren);
            } else if(direction === 'previous') {
                movableChildren = $(children.slice((children.length - (numAcross)), children.length));
                $wrap.prepend(movableChildren);
            }

            // Get the children again because we changed the order
            children = $wrap.children();

            // Create the new clones
            if(children.length > numAcross) {
                var startChildren = $(children.slice((children.length - (numAcross)), children.length)).clone();
                startChildren.addClass('slide-clone');
                $wrap.prepend(startChildren);

                var endChildren = $(children.slice(0, numAcross)).clone();
                endChildren.addClass('slide-clone');
                $wrap.append(endChildren);
            }

            resetPlacement();
        }

        // Resets the placement of the elements
        function resetPlacement() {
            // Get the main elements width
            var width = $element.width();
            // Get the number across we are currently showing
            var numAcross = getNumAcross();
            // Get all the slides
            var children = $wrap.children();

            // Set the childrens width to the width of the main
            // elements width if we are only showing 1
            if(numAcross === 1)
                children.width(Math.round(width));
            // Else remove our set width
            else
                children.css('width', '');

            // Reset the main $wrap element to its starting position
            if(children.length > numAcross) {
                $wrap
                    .css('transform', ['translateX(-', width, 'px)'].join(''))
                    .width(Math.ceil(children.length / getNumAcross()) * $element.width());
            }
        }

        // Animate the slides when an arrow is clicked
        function onArrowClick(direction) {
            if(vm.model.animating) return;

            var animate;
            // Get the number across we are currently showing
            var numAcross = getNumAcross();
            // Get the main elements width
            var width = $element.width();

            // Set the animate direction and the currentSlide
            if(direction === 'next') {
                vm.model.currentSlide += numAcross;
                animate = { transform: ['+=', 'translateX(-', width, 'px)'].join('') };
            } else {
                vm.model.currentSlide -= numAcross;
                animate = { transform: ['+=', 'translateX(', width, 'px)'].join('') };
            }

            // We set animating to true so you cant keep
            // clicking the arrows.
            vm.model.animating = true;

            // Animate to the slide
            $wrap.animate(animate, speed, function () {
                $timeout(function () {
                    reorderChildren(direction);
                    vm.model.animating = false;
                }, 100);
            });

            // Fire the onSlideChange event
            vm.onSlideChange({
                $direction: direction,
                $currentSlide: vm.model.currentSlide
            });
        }

        function onWindowResize(e) {
            $scope.$applyAsync(reorderChildren);
        }


        ///////////////////////////////////////////////////
        // Touch & Slide
        ///////////////////////////////////////////////////
        var startX;
        // The max size we consider mobile
        var mobileMaxWidth = 600;
        // The minimum horizontal amount you have to drag
        // before we disable vertical dragging.
        var minHorizontalDrag = 25;
        // The minimum amount you have to drag in order
        // for it to go to the next slide.
        var dragThreshold = 100;

        function onTouchStart(e, touchData) {
            // Only continue if we are on mobile
            if(window.innerWidth >= mobileMaxWidth) return;

            vm.model.dragging = true;
            startX = touchData.pageX;

            // Start listening for the touch move event.
            $lrTouchMove(angular.element(e.target), onTouchMove);
            // Start listening for the touch end event.
            $lrTouchEnd(angular.element(e.target), onTouchEnd);

            // Run the angular $digest.
            $scope.$digest();
        }

        function onTouchMove(e, touchData) {
            var endX = touchData.pageX;
            // Calculate how in which direction the
            // $wrap element has been dragged.
            var diffAmount = startX - endX;

            // check if the element has been dragged past
            // our min amount. If so prevent vertical dragging.
            if(Math.abs(diffAmount) > minHorizontalDrag) {
                // Prevent vertical scrolling.
                e.preventDefault();
                // Move the $wrap element.
                $wrap.css('marginLeft', -diffAmount);
                // Run the angular $digest.
                $scope.$digest();
            }
        }

        function onTouchEnd(e) {
            $scope.$applyAsync(function () {
                var animate;
                // Get the current amount the $wrap element has been dragged.
                var amount = parseInt($wrap.css('marginLeft'));
                // Get the number across we are currently showing. Because
                // this is most likely mobile it will usually be 1.
                var numAcross = getNumAcross();

                // Check if we are past the min drag threshold.
                if(Math.abs(amount) > dragThreshold) {
                    // Set the main elements width.
                    var width = $element.width();
                    // Get the speed based on how far the $wrap
                    // element was dragged.
                    var partialSpeed = speed * (1 - Math.abs(amount) / width);
                    // Set which direction the user was dragging.
                    var direction = amount > 0 ? 'previous' : 'next';

                    // Set the animate var. This sets up the animation
                    // based on the swipe direction.
                    if(amount > 0) {
                        vm.model.currentSlide -= numAcross;
                        animate = { transform: ['+=', 'translateX(', width, 'px)'].join(''), marginLeft: 0 };
                    } else {
                        vm.model.currentSlide += numAcross;
                        animate = { transform: ['+=', 'translateX(-', width, 'px)'].join(''), marginLeft: 0 };
                    }

                    // Start animating
                    $wrap.animate(animate, partialSpeed, function () {
                        $timeout(function () {
                            reorderChildren(direction);
                        }, 100);
                    });

                    // Fire the onSlideChange event.
                    vm.onSlideChange({
                        $direction: direction,
                        $currentSlide: vm.model.currentSlide
                    });
                } else {
                    // Put the element back to start
                    $wrap.animate({ marginLeft: 0 });
                }

                vm.model.dragging = false;
                angular.element(e.target).off('touchmove');
                angular.element(e.target).off('touchend');
            });
        }

        function removeTouchListeners() {
            $wrap.off('touchstart', onTouchStart);
            $wrap.off('touchmove', onTouchMove);
            $wrap.off('touchend', onTouchEnd);
        }


        ///////////////////////////////////////////////////
        // init
        ///////////////////////////////////////////////////
        (function init() {
            var children = $element.find('.lrcarousel-wrap').children();

            // only continue if the children have
            // been rendered
            if(!children.length) {
                return $timeout(init, 500);
            }

            // Set our default class and give each
            // slide an id.
            children.each(function (index) {
                $(this)
                    .addClass('lrcarousel-slide')
                    .attr('slideId', 'slide-' + index);
            });

            // Display the main element
            $element.css('display', '');
            // Start listening for touch events
            $lrTouchStart($($element.find('.lrcarousel-wrap')), onTouchStart);
            // Reset anything that needs to be reset
            reorderChildren();
            // Listen for when the window is resized.
            $window.on('resize', onWindowResize);
            // Fire the onInit event
            vm.onInit();
        })();


        ///////////////////////////////////////////////////
        // $on $destroy
        ///////////////////////////////////////////////////
        $scope.$on('$destroy', function () {
            $window.off('resize', onWindowResize);
            removeTouchListeners();
        });
    }
]);

_module.directive('lrcarousel', function () {
    return {
        restrict: 'E',
        template: require('./index.html'),
        controllerAs: 'vm',
        controller: 'LRCarouselCtrl',
        bindToController: true,
        scope: {
            data: '=?',
            numAcross: '@',
            onInit: '&',
            onSlideChange: '&'
        },
        transclude: true,
        priority: 999
    };
});
